import LayoutWithMenu from "../components/LayoutWithMenu";
import {graphql} from "gatsby";
import React, {useEffect} from "react";
import useTranslateOrDefault from "../hooks/useTranslateOrDefault";
import FeedbackLink from "../components/FeedbackLink";

/**
 * Template to display any doc page.
 */
export default function DocPage({data}) {
    const post = data.markdownRemark;
    const pageType: string = useTranslateOrDefault(`page-type-${post?.fields?.pageType}`, "docs.cloudogu.com");
    const location = [pageType, ...(post?.fields?.folders ?? []), post?.fields?.title]
    const appTitle: string = useTranslateOrDefault("app-title", "docs.cloudogu.com");

    useEffect(() => {
        document.title = `${post?.fields?.title ?? "-"} | ${appTitle}`
    });

    return (
        <LayoutWithMenu
            location={location as string[]}
            frontmatter={post?.frontmatter}
            delocalizedSlug={data?.markdownRemark?.fields?.delocalizedSlug}
            navigationMarkdownEdges={data.allMarkdownRemark.edges}
            baseLocation={post?.fields?.pageType}
            toc={
                <div>
                    <div dangerouslySetInnerHTML={{__html: post?.tableOfContents}}/>
                </div>
            }
            children={
                <div>
                    <div dangerouslySetInnerHTML={{__html: post?.html}}/>
                    <FeedbackLink link={data.site.siteMetadata.feedbackForumUrl}/>
                </div>
            }
        />
    )
};

export function getBaseSlug(node) {
    if (node.fields.folders.length > 0) {
        return `/usermanual/${node.fields.folders[0]}/`
    }

    return node.fields.delocalizedSlug;
}

export const query = graphql`
query ($slug: String!, $pageType: String!, $locale: String!) {
  markdownRemark(fields: {delocalizedSlug: {eq: $slug}, pageType: {eq: $pageType}, locale: {eq: $locale}}) {
    html
    frontmatter {
      title
      canonical
    }
    fields {
      folders
      delocalizedSlug
      title
      pageType
    }
    tableOfContents(
        absolute: true
        pathToSlugField: "fields.localizedSlug"
    )
  }
  allMarkdownRemark(filter: {fields: {pageType: {eq: $pageType}, locale: {eq: $locale}}}) {
    edges {
      node {
        fields {
          slug
          delocalizedSlug
          title
          folders
          pageType
          delocalizedElement
        }
      }
    }
  }
  site {
    siteMetadata {
      feedbackForumUrl
    }
  }
}

`
